import React from 'react'
import { Button } from 'antd'

interface IRefinancingButtonProps {
  loading?: boolean
  isContinueDisabled?: boolean
  handleClick?: () => void
}
export default function RefinancingButton ({ loading, isContinueDisabled, handleClick }: IRefinancingButtonProps) {
  return (
    <div className='flex flex-justify-end mt-4'>
      <Button
        htmlType='button'
        className={`refinancing-button${isContinueDisabled ? '-disabled' : ''}`}
        loading={loading}
        disabled={isContinueDisabled}
        onClick={handleClick}
      >
        Continuar
      </Button>
    </div>
  )
}
